import AtelierSidebar from '@/components/sidebar/AtelierSidebar'
import BoutiqueSidebar from '@/components/sidebar/BoutiqueSidebar'
import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'

export default function Sidebar() {
  const organization = usePage<SharedProps>().props.current_organization!

  if (organization.kind_store) return <BoutiqueSidebar />
  return <AtelierSidebar />
}
